import React from 'react';
import TextInput from 'common/components/Form/TextInput';

// A wrapper for <TextInput> when used with a redux-form
// Redux <Field> wraps certain props before passing them along,
// if we want them to work with our custom TextInput then we need to unwrap.
// https://redux-form.com/7.1.1/docs/api/field.md/#props
const TextInputRedux = props => {
  const getError = () => (props.meta.touched ? props.meta.error : undefined);

  const combinedProps = {
    error: getError(),
    inputProps: {
      disabled: props.disabled,
      value: props.input.value,
    },
    ...props,
    ...props.input,
  };

  return <TextInput {...combinedProps} />;
};

export default TextInputRedux;
